<template>
  <div  class="footerchat">
    <form :class="{disabled: (disableInput)}" v-on:submit.prevent="writeMessage(message)">
      <input
        placeholder="Scrivi il tuo messaggio..."
        v-model="message"
        @keypress="writingMessage(event)"
        @keyup="checkInput"
        :disabled="disableInput"
      />
      <button type="button" @click="writeMessage(message);" :disabled="message == ''">
        <font-awesome-icon icon="arrow-up" />                
      </button>
    </form>
  </div>
</template>
<script>
import ChatMessageTextBoxRepository from './../repositories/ChatMessageTextBoxRepository';

export default {
  name: "chatfooter",
  mixins: [ChatMessageTextBoxRepository], 
  data() {
    return {
      message: "",
      event: "",
      disableInput:true,
      ConversationId:0,
    };
  }
};
</script>
<style>
.footerchat {
  position: relative;
  width: 100%;
  bottom: 0px;
  left: 0px;
  background-color: #fff;
  z-index: 99;
  padding: 18px 14px;
  border-top: 1px solid #ccc; 
  border-left: 1px solid #ccc; 
  height: 75px;
}
.footerchat input {
  border-radius: 25px;
  border: 1px solid #c1c1c1;
  padding: 4px 14px;
  width: calc(100% - 53px);
  height: 40px;
}
.footerchat input:focus,
footerchat button:focus {
  outline: none;
}
.footerchat button {
  border-radius: 50%;
  -webkit-appearance: none;
  border: none;
  height: 40px;
  width: 40px;
  text-align: center;
  margin-left: 10px;
}
.footerchat button[disabled] {
  opacity: 0.5;
}
</style>